"use client";

interface VestraLogoMarkProps {
  size?: number;
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
  alt?: string;
}

export function VestraLogoMark({
  size = 16,
  width,
  height,
  className,
  style,
  title,
  alt = "Vestra",
}: VestraLogoMarkProps) {
  return (
    <img
      src="/vestra.svg"
      alt={alt}
      title={title}
      className={className}
      style={{ width: width ?? size, height: height ?? size, ...style }}
    />
  );
}
